import React, { Component } from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';


class RegularSearch extends Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            year: 2019,
        }
    }
    handleChange(event) {
        this.setState({ year: event.target.value })
        this.props.onUpdate('year', event.target.value)
    }
    render() {
        return (
            <div>
                {/* TODO: Create regular search on instituut and name. in all courses en knowledge, and filter this per type of page. */}
                <Form horizontal className="regularSearchYear">
                    <FormGroup controlId="regularSearchBoxYear">
                        <Col componentClass={ControlLabel} sm={4}>
                            Jaar
                            </Col>
                        <Col sm={4}>
                            <FormControl name="year" value={this.state.year} componentClass="select" onChange={this.handleChange}>
                                <option value="0">Geen datum</option>
                                <option value="2026">2026</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                            </FormControl>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    };

}

export default RegularSearch;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/Toevoegen/RegularSearchYear.js